import React from 'react';
import { Link } from 'react-router-dom';
import {
  SidebarContainer,
  Icon,

  SidebarWrapper,
  SidebarMenu,
  SidebarLink,
  WrapperButton,
  ButtonWhite,
  ButtonBlack,
} from '../Sidebar/SidebarElements';
import './styles.css';
import close from '../../assets/images/x.svg';
import { ButtonPurple } from '../Footer/styles';

import icon from '../../assets/loginDashboard_.png'
import { IoCloseSharp } from "react-icons/io5";
import { WrapperBar } from '../Navbar/NavbarElements';
const Sidebar = ({ isOpen, toggle }) => {
  return (
    <SidebarContainer isOpen={isOpen} onClick={toggle}>
      <Icon onClick={toggle}>
        {/* <img src={close} className="close" /> */}
        <IoCloseSharp color="#fff" size={32} />
      </Icon>
      <SidebarWrapper>
        <SidebarMenu>

          <SidebarLink onClick={toggle}>
            <Link to="/about-us">ABOUT US</Link>
          </SidebarLink>

          <SidebarLink onClick={toggle}>
            <Link to="/services">SERVICES</Link>
          </SidebarLink>

          <SidebarLink onClick={toggle}>
            <Link to="/locations">LOCATIONS</Link>
          </SidebarLink>
          <SidebarLink onClick={toggle}>
            <Link to="/reviews">REVIEWS</Link>
          </SidebarLink>
          <SidebarLink onClick={toggle}>
            <Link to="/customers">CUSTOMERS</Link>
          </SidebarLink>

          <SidebarLink onClick={toggle}>
            <Link to="/providers">PROVIDERS</Link>
          </SidebarLink>

          <SidebarLink onClick={toggle}>
            <Link to="/our-goals">OUR GOALS</Link>
          </SidebarLink>
          <SidebarLink onClick={toggle}>
            <Link to="/contact-us">CONTACT US</Link>
          </SidebarLink>

          <SidebarLink onClick={toggle}>
            <Link to="/faq">FAQ</Link>
          </SidebarLink>

          <WrapperButton>
            <Link to='/customer'>
              <ButtonWhite onClick={() => window.open('https://dashboard.xgreen.app', "_blank")}>
                BOOK NOW
              </ButtonWhite>
            </Link>
            <Link to='/rewards'>
              <ButtonPurple style={{ width: '290px' }}>
                REWARDS
              </ButtonPurple>
            </Link>

            <Link to="/" onClick={() => window.open('https://dashboard.xgreen.app', "_blank")}>
              <img src={icon} style={{ width: '48px', height: '48px' }} />
            </Link>

          </WrapperButton>

        </SidebarMenu>

      </SidebarWrapper>

    </SidebarContainer>
  );
};

export default Sidebar;
